import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const KEY = "av_cookies_v1";

export default function CookieBanner() {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            if (!localStorage.getItem(KEY)) {
                const tt = setTimeout(() => setVisible(true), 700);
                return () => clearTimeout(tt);
            }
        } catch (_) {
            setVisible(true);
        }
    }, []);

    const decide = (choice) => {
        try {
            localStorage.setItem(KEY, choice);
        } catch (_) {}
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            data-testid="cookie-banner"
            role="dialog"
            aria-live="polite"
            className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60] bg-[#1A1A1A] text-[#F4F1EA] border border-[#8B6914] p-5 shadow-xl"
        >
            <p className="text-sm leading-relaxed">{t("cookies.message")}</p>
            <div className="mt-4 flex gap-3">
                <button
                    data-testid="cookie-reject"
                    onClick={() => decide("rejected")}
                    className="text-xs px-4 py-2 border border-[#A4A19A] text-[#F4F1EA] hover:border-[#8B6914] hover:text-[#8B6914] transition-colors"
                >
                    {t("cookies.reject")}
                </button>
                <button
                    data-testid="cookie-accept"
                    onClick={() => decide("accepted")}
                    className="text-xs px-4 py-2 bg-[#8B6914] text-white hover:bg-[#A47F1E] transition-colors"
                >
                    {t("cookies.accept")}
                </button>
            </div>
        </div>
    );
}
